import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm } from '@angular/forms';
import { AuthenticationService } from '../services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertsService } from 'angular-alert-module';
import { ChangePassword } from './change_password.model';
import Swal from 'sweetalert2';
@Component({
  templateUrl: './change_password.component.html',
  styleUrls: [ './change_password.component.scss' ]
})

export class ChangePasswordComponent {
  myForm: FormGroup;
  submitted: boolean = false;
  oldpassword;
  newpassword;
  pin;
  // Form controls
  pswd = new FormGroup({
    email: new FormControl(''),
    oldpassword: new FormControl(''),
    newpassword: new FormControl('')
  });

  password: ChangePassword = {
    email: '',
    oldpassword: '',
    newpassword: ''
  };

  constructor(private auth: AuthenticationService, private router: Router, private route: ActivatedRoute,
              private formBuilder: FormBuilder, private alerts: AlertsService) {}

    ngOnInit() {
      this.myForm = this.formBuilder.group(
        {
          email: ['', [Validators.required, Validators.email]],
          oldpassword: ['', [Validators.required, Validators.minLength(5)]],
          newpassword: ['', [Validators.required, Validators.minLength(5)]]
        }
      );

      // this.route.params.subscribe(params => {
      //   this.pin = params['pin'];
      // });
      //
    }
    get f() { return this.myForm.controls; }

    changepassword() {
      this.submitted = true;
      this.auth.changepassword(this.password).subscribe(
        (data) => {
          this.submitted = true;

          if (data.code === 200) {
            
            Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/');
              }
            })
          } else if (data.code === 400) {
              Swal.fire({
                title: 'Alert',
                text: data.failed,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'OK'
              }).then((result) => {
                if (result.isConfirmed) {
                  // this.router.navigateByUrl('/test_scheduler');
                }
              })

            }
          },
        err => {
          console.error(err);
          Swal.fire({
            title: 'Alert',
            text: 'Email id does not exist' ,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })
        }
      );
    }

    Oncancel() {
        this.router.navigateByUrl('/');
    }
}
